"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var login_js_1 = require("./login/login.js");
exports.loginValidator = login_js_1.loginValidator;
var register_js_1 = require("./register/register.js");
exports.registerSchoolValidator = register_js_1.registerSchoolValidator;
exports.registerStudentValidator = register_js_1.registerStudentValidator;
exports.registerPasswordValidator = register_js_1.registerPasswordValidator;
var districtSchool_js_1 = require("./districtSchool/districtSchool.js");
exports.districtSchoolValidator = districtSchool_js_1.districtSchoolValidator;
var index_1 = require("./pathValidations/index");
exports.pathValidationFactory = index_1.default;
var subjectAreas_1 = require("./pathValidations/subjects_data/subjectAreas");
exports.subjectAreas = subjectAreas_1.default;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ../validation/build/index.js
// module id = 51
// module chunks = 22